import {
  createApiService,
  catchErrorHandler,
  createTokenService,
  memoryStorage,
  setAppApiOptions,
} from '@alycecom/services';
import { of, throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { AjaxResponse } from 'rxjs/ajax';

const successResponseHandler = [
  mergeMap(({ response, status }: AjaxResponse) => {
    const redirectUrl = response?.redirectUrl || (response?.data && response?.data?.redirectUrl);
    if (status === 300 && window.location.href !== redirectUrl) {
      window.location.href = redirectUrl;
      return throwError({
        name: 'Redirect',
        status,
        response,
      });
    }
    return of(response);
  }),
  catchError(catchErrorHandler),
];

const tokenService = createTokenService({ storageService: memoryStorage });

setAppApiOptions({ baseUrl: window.APP_CONFIG.apiHost, getToken: () => tokenService.getToken() ?? '' });

export const apiService = createApiService({
  baseUrl: window.APP_CONFIG.apiHost,
  tokenService,
  successResponseHandler,
});
